export default function WebinarVaultLogo({ height = 36, className = "", color = "#ffffff", accentColor = "#3b82f6" }) {
  const scale = height / 40;
  const iconSize = height * 0.75;
  return (
    <span className={`webinarvault-logo ${className}`} style={{ display: "inline-flex", alignItems: "center", gap: 6 * scale }}>
      <svg viewBox="0 0 28 28" fill="none" style={{ width: iconSize, height: iconSize }}>
        <circle cx="12" cy="12" r="11" stroke={accentColor} strokeWidth="2.5" fill="none" />
        <path d="M10 8.5v7l5.5-3.5L10 8.5z" fill={accentColor} />
        <line x1="20.5" y1="20.5" x2="26" y2="26" stroke={accentColor} strokeWidth="2.5" strokeLinecap="round" />
      </svg>
      <span style={{
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        fontWeight: 700,
        fontSize: height * 0.65,
        letterSpacing: "-0.02em",
        color,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}>
        WebinarVault
      </span>
    </span>
  );
}
